import React from 'react';

function ClientSettingPersonalInfo(){

    return (
       
        <>
<div class="col-sm-7">
        
               <div className="card" style={{ width: "18rem;" }}>
        <div className="card-body">
          <div style={{ display: "flex" }}>
          <p className="card-title">
                <strong> Edit Personal Information</strong>{" "}
                
              </p>
          
{/* 
            <span className="leftAling" style={{ display: "flex" }}>
          
              <span className="info">
                <span class="material-symbols-rounded">more_horiz</span>
              </span>
            </span>*/}
          </div>

        {/*  <div className="d-flex">
            <div className="smallInfo" style={{ display: "flex" }}>
              <span class="material-symbols-rounded writing">
                battery_5_bar
              </span>{" "}
              <span style={{ marginTop: "-3px", paddingLeft: "5px" }}>
                <strong>
                  Min 
                </strong>
              </span>
              <p className="Font-primary currentCharging">26.07 V</p>
           
            </div>

            <div className="smallInfo" style={{ display: "flex" }}>
              <span class="material-symbols-rounded writing">
                battery_5_bar
              </span>{" "}
              <span style={{ marginTop: "-3px", paddingLeft: "5px" }}>
                <strong>
                  Max 
                </strong>
              </span>
              <p className="Font-primary currentCharging">56.07 V</p>
           
            </div>
          </div> */}
          <hr />


          <div class="row">

<div class="col-sm-12">

</div>

    <div class="col-sm-4">


          <div className="">

          <div className="smallInfo" style={{ display: "flex" }}>
              <span class="material-symbols-rounded writing">
                person
              </span>{" "}
              <span style={{ marginTop: "-3px", paddingLeft: "5px", paddingBottom:"10px" }}>
                <strong>
                  Name:
                </strong>
              </span>
           
            </div>
        
            <input
            type="text"
            className="Login-form-field Login-animation a4"
            name=""
            placeholder="Name"
            style={{ width:"90%" }}
            />
        </div>
    </div>

    <div class="col-sm-4">
          <div className="">

        <div className="smallInfo" style={{ display: "flex" }}>
              <span class="material-symbols-rounded writing">
                mail
              </span>{" "}
              <span style={{ marginTop: "-3px", paddingLeft: "5px", paddingBottom:"10px" }}>
                <strong>
                  Email:
                </strong>
              </span>
           
        </div>
         
            <input
            type="text"
            className="Login-form-field Login-animation a4"
            name=""
            placeholder="Email"
            style={{ width:"90%" }}
            />
        </div>
    </div>
    <div class="col-sm-4">


<div className="">

<div className="smallInfo" style={{ display: "flex" }}>
              <span class="material-symbols-rounded writing">
                phone
              </span>{" "}
              <span style={{ marginTop: "-3px", paddingLeft: "5px", paddingBottom:"10px" }}>
                <strong>
                  cell:
                </strong>
              </span>
           
        </div>

  <input
  type="text"
  className="Login-form-field Login-animation a4"
  name=""
  placeholder="Cell"
  style={{width:"90%" }}
  />
</div>
</div>



</div>


<hr />

<div class="row">

<div class="col-sm-12">
<div style={{display: "flex"}}>
        <p className="card-title"><strong>Address Information </strong></p>
    </div>
</div>

<div class="col-sm-4">


<div className="">

<div className="smallInfo" style={{ display: "flex" }}>
              <span class="material-symbols-rounded writing">
                home
              </span>{" "}
              <span style={{ marginTop: "-3px", paddingLeft: "5px" }}>
                <strong>
                  address:
                </strong>
              </span>
           
            </div>

  <input
  type="text"
  className="Login-form-field Login-animation a4"
  name="address"
  placeholder="Address"
  style={{ marginTop: "10px", width:"90%" }}
  />
</div>
</div>

    <div class="col-sm-4">

    <div className="smallInfo" style={{ display: "flex" }}>
              <span class="material-symbols-rounded writing">
              location_city
              </span>{" "}
              <span style={{ marginTop: "-3px", paddingLeft: "5px" }}>
                <strong>
                  City:
                </strong>
              </span>
           
            </div>


          <div className="">
        
            <input
            type="text"
            className="Login-form-field Login-animation a4"
            name=""
            placeholder="City"
            style={{ marginTop: "10px", width:"90%" }}
            />
        </div>
    </div>

    
    <div class="col-sm-4">

    <div className="smallInfo" style={{ display: "flex" }}>
              <span class="material-symbols-rounded writing">
              location_home
              </span>{" "}
              <span style={{ marginTop: "-3px", paddingLeft: "5px"}}>
                <strong>
                  Province:
                </strong>
              </span>
           
            </div>


          <div className="">
        
            <input
            type="text"
            className="Login-form-field Login-animation a4"
            name=""
            placeholder="Province"
            style={{ marginTop: "10px", width:"90%" }}
            />
        </div>
    </div>

    <div class="col-sm-4">

    <div className="smallInfo" style={{ display: "flex", marginTop:"32px" }}>
              <span class="material-symbols-rounded writing">
              flag
              </span>{" "}
              <span style={{ marginTop: "-3px", paddingLeft: "5px", }}>
                <strong>
                  Country:
                </strong>
              </span>
           
            </div>

      
          <div className="">

            
         
          <select  id="cars" name="cars" className="Login-form-field Login-animation a4 selectForm" style={{ marginTop: "9px", width:"90%" }}>
            <option value="" disabled selected>Country</option>
            <option value="Z-Range">South Africa</option>
            <option value="Giga-Rack">Lesotho</option>
          </select>

        </div>
    </div>

    <div class="col-sm-4" style={{marginTop:"10px"}}>

    <div className="smallInfo" style={{ display: "flex", marginTop:"20px" }}>
              <span class="material-symbols-rounded writing">
              location_home
              </span>{" "}
              <span style={{ marginTop: "-3px", paddingLeft: "5px", }}>
                <strong>
                  Code:
                </strong>
              </span>
           
            </div>


<div className="">

  <input
  type="text"
  className="Login-form-field Login-animation a4"
  name=""
  placeholder="Code"
  style={{ marginTop: "10px", width:"90%" }}
  />
</div>
</div>


</div>

<hr style={{marginTop:"40px", marginBottom:"20px"}} />


<button className="btn2 btn-default" style={{marginRight:"20px"}} >Update</button>


        </div>
      </div>
      </div>
        </>
    )
}

export default ClientSettingPersonalInfo;